<template>
  <div class="home_wrap">
    <div
      ref="homeScroll"
      class="home-scroll"
    >
      <div class="red_top_bg home-top">
        <!--        <button
          type="button"
          class="language"
          @click="$router.push('/language')"
        >
          <img
            :src="require('../images/language/' + lang + '.png')"
            alt=""
          >
        </button> -->
        <div class="brand-box">
          <img
            class="logo"
            src="../images/ban3/slogo.png"
          >
        </div>
        <button
          type="button"
          class="service"
          @click="$router.push('/notice')"
        >
          <van-icon
            name="smile-comment"
            size="25"
            color="#fff"
          />
        </button>
      </div>

      <van-swipe
        v-if="banner"
        class="hero-swipe"
        :autoplay="3000"
        lazy-render
      >
        <van-swipe-item
          v-for="(item, index) in banner"
          :key="index"
        >
          <img
            :src="item[lang]"
            alt=""
          >
        </van-swipe-item>
      </van-swipe>

      <div
        v-if="notifyStr"
        class="notice-card"
      >
        <van-icon
          name="volume"
          class="notice-icon"
        />
        <div class="notice-text">
          <marquee
            scrollamount="3"
            behavior="scroll"
          >
            {{ notifyStr }}
          </marquee>
        </div>
      </div>

      <div class="quick-actions">
        <div
          v-for="item in quickActions"
          :key="item.name"
          class="quick-action"
          @click="goQuickAction(item)"
        >
          <img
            :src="item.icon"
            alt=""
          >
          <span class="quick-action-label">{{ $t(item.labelKey) }}</span>
        </div>
      </div>
      <!-- 
      <section class="popular-city-card">
        <div class="popular-city-label">
          {{ $t('sky.popularCity') }}:
        </div>
        <div class="popular-city-content">
          <div class="popular-city-grid">
            <span
              v-for="cityKey in popularCityKeys"
              :key="cityKey"
              class="popular-city-item"
              @click="$router.push('/vchoose')"
            >
              {{ $t('sky.' + cityKey) }}
            </span>
          </div>
          <span
            class="popular-city-more"
            @click="$router.push('/vchoose')"
          >
            {{ $t('sky.otherRegion') }}
          </span>
        </div>
      </section> -->

      <section
        v-if="girls.length || !girlsFinished"
        class="girls-list-wrap"
      >
        <div class="section-title">
          {{ $t('sky.tuijian') }}
        </div>
        <van-list
          v-model="girlsLoading"
          :finished="girlsFinished"
          :immediate-check="false"
          :offset="100"
          :loading-text="$t('pro2.loading')"
          @load="loadGirls"
        >
          <article
            v-for="item in girls"
            :key="item.id"
            class="girl-card"
            @click="$router.push('/vprofile/' + item.id)"
          >
            <div class="girl-media">
              <img
                :src="formatAssetUrl(item.pic)"
                alt=""
              >
              <span class="corner-ribbon">
                <i>{{ $t('sky.gaoduan') }}</i>
              </span>
            </div>
            <div class="girl-info">
              <div class="girl-topline">
                <span class="verify-chip">
                  <img
                    src="../images/home/vip.png"
                    alt=""
                  >
                  {{ $t('sky.renzheng') }}
                </span>
                <span class="verify-chip">
                  <img
                    src="../images/home/vip.png"
                    alt=""
                  >
                  {{ $t('sky.shirenzheng') }}
                </span>
              </div>
              <h3>{{ item.name }}</h3>
              <div class="tags">
                <span
                  v-for="tag in getGirlTags(item)"
                  :key="tag"
                  class="tag"
                >
                  {{ tag }}
                </span>
              </div>
              <div class="rating-row">
                <span>{{ $t('sky.fee') }}:</span>
                <van-icon
                  v-for="star in 5"
                  :key="star"
                  name="star"
                  class="star"
                />
              </div>
              <div class="meta-row">
                <span>{{ $t('sky.height') }}: {{ item.height }}CM</span>
                <span>{{ $t('sky.high') }}: {{ item.xiong }}</span>
              </div>
              <div class="meta-row">
                <span>{{ $t('sky.fuwu') }}: {{ $t('sky.country') }}</span>
              </div>
              <button
                type="button"
                class="date-btn"
              >
                {{ $t('sky.yue') }}
              </button>
            </div>
          </article>
        </van-list>
      </section>
    </div>

    <van-dialog
      v-model="show_tc"
      width="90%"
      :confirm-button-text="$t('utils.confirm')"
    >
      <img
        class="dialog-img"
        src="../images/index/tanchuang.png"
        alt=""
      >
      <div
        class="popup"
        v-html="tc_content"
      />
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { formatAssetUrl } from "../../utils/assets";
import {
	Swipe,
	SwipeItem,
	Icon,
	Dialog,
	List,
} from "vant";

Vue.use(Icon).use(Dialog).use(List);

export default {
	name: "Index",
	components: {
		VanSwipe: Swipe,
		VanSwipeItem: SwipeItem,
	},
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			loading: false,
			randomNumber: 0,
			data: {
				item1: { show: true },
				item2: { show: true },
				item3: { show: true },
			},
			app: {},
			islogin: false,
			isapp: false,
			show_tc: false,
			tc_content: "",
			vip: null,
			girls: [],
			girlsPage: 1,
			girlsLoading: false,
			girlsFinished: false,
			girlsRequestLock: false,
			girlsLoadedPages: {},
			banner: null,
			items: null,
			cashes: null,
			coindatas: null,
			quickActions: [
				{ name: "wallet", path: "/moneybag", icon: require("../images/ban3/duihuan.png"), labelKey: "home.wallet" },
				{ name: "notice", path: "/about/33", icon: require("../images/ban3/notice.png"), labelKey: "notice.message" },
				{ name: "favorite", path: "/item", icon: require("../images/ban3/m3cur.png"), labelKey: "sky.vote" },
				{ name: "vip", path: "/vip", icon: require("../images/ban3/vip2.png"), labelKey: "vipPage.title" },
			],
			popularCityKeys: [
				"cityGangwon",
				"cityGyeonggi",
				"cityGyeongsangnam",
				"cityGyeongsangbuk",
				"cityGwangju",
				"cityDaegu",
				"cityDaejeon",
				"cityBusan",
				"citySeoul",
				"citySejong",
				"cityUlsan",
				"cityIncheon",
				"cityJeollanam",
				"cityJeollabuk",
				"cityJeju",
				"cityChungcheongnam",
				"cityChungcheongbuk",
			],
			notifyStr: "",
		};
	},
	created() {
		this.$parent.footer("home");
	},
	mounted() {
		this.islogin = localStorage.getItem("token") != null;
		if (!this.islogin) {
			this.$router.push("/login");
		}

		this.start();
		this.$nextTick(() => {
			this.loadGirls();
		});

		if (this.$router.history.current.query.agent) {
			localStorage.setItem("agent", this.$router.history.current.query.agent);
		}
		if (this.$router.history.current.query.isapp) {
			localStorage.setItem("isapp", "true");
		}
		this.isapp = localStorage.getItem("isapp") != null;
	},
	methods: {
		formatAssetUrl,
		getcoinsdata() {
			Fetch("/user/getcoinsdata").then(r => {
				this.coindatas = JSON.parse(r.data);
			});
		},
		download() {
			var downloadurl = document.createElement("A");
			downloadurl.href = this.app.app_link;
			downloadurl.target = "blank";
			downloadurl.click();
		},
		goQuickAction(item) {
			if (item.name === "vip") {
				Dialog.alert({
					title: this.$t("pro2.explanation"),
					confirmButtonText: this.$t("shopd.surebtn"),
					message: this.$t("pro2.vipapply"),
					theme: "round-button",
				});
			} else {
				this.$router.push(item.path);
			}
		},
		start() {
			Fetch("/index/int").then(r => {
				this.data = r.data;
				this.vip = r.data.vip;
				this.banner = r.data.banner;
				this.notifyStr = r.data.notice;
				this.cashes = r.data.cashes;
				this.items = r.data.items;
				this.randomNumber = Math.floor(Math.random() * (7800 - 6877 + 1)) + 6877;
				this.loading = true;

				if (r.data.popup.show == 1) {
					this.tc_content = r.data.popup.content;
					if (localStorage.getItem("tc") != this.tc_content) {
						localStorage.setItem("tc", this.tc_content);
						this.show_tc = true;
					}
				}
			});

			Fetch("/index/webconfig").then(r => {
				this.app = r.data;
			});
		},
		loadGirls() {
			if (this.girlsRequestLock || this.girlsFinished) {
				this.girlsLoading = false;
				return;
			}
			if (this.girlsLoadedPages[this.girlsPage]) {
				this.girlsLoading = false;
				return;
			}

			this.girlsRequestLock = true;
			var currentPage = this.girlsPage;
			this.$set(this.girlsLoadedPages, currentPage, true);

			Fetch("/index/girls", {
				page: currentPage,
			}).then(r => {
				var data = r.data || {};
				var list = data.list || [];

				for (var i = 0; i < list.length; i++) {
					list[i].keys = list[i].keystr ? list[i].keystr.split("|") : [];
				}

				var existsMap = {};
				for (var j = 0; j < this.girls.length; j++) {
					existsMap[this.girls[j].id] = true;
				}

				var newList = list.filter(item => {
					return item.id && !existsMap[item.id];
				});

				if (newList.length > 0) {
					this.girls = this.girls.concat(newList);
					this.girlsPage++;
				}

				this.girlsFinished = !data.has_more;
				this.girlsLoading = false;
				this.girlsRequestLock = false;
			}).catch(() => {
				this.$delete(this.girlsLoadedPages, currentPage);
				this.girlsLoading = false;
				this.girlsRequestLock = false;
			});
		},
		getGirlTags(item) {
			return item && item.keys ? item.keys.slice(0, 4).filter(Boolean) : [];
		},
	},
};
</script>

<style lang="less" scoped>
.home_wrap {
	width: 100%;
	min-height: 100vh;
	--accent: #ff5d7a;
	--accent-strong: #ff4f70;
	--accent-soft: #fff1f5;
	--accent-line: #ffdbe4;
	--text: #16223a;
	--muted: #6d7688;
	--shadow: 0 12px 28px rgba(255, 93, 122, 0.13);
	background: #fff;
	color: var(--text);
	overflow: hidden;
}

.home-scroll {
	height: 100vh;
	overflow-y: auto;
	padding-bottom: 88px;
	box-sizing: border-box;
	-webkit-overflow-scrolling: touch;
}

.home-top {
	position: sticky;
	top: 0;
	z-index: 10;
	height: 52px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	background: linear-gradient(180deg, #ff748f 0%, #ff5574 100%);
	border-bottom: 1px solid rgba(255, 255, 255, 0.24);
	box-sizing: border-box;
}

.brand-box {
	min-width: 0;
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-left: 32px;
}

.logo {
	max-width: 168px;
	object-fit: contain;
}

.service {
	width: 32px;
	height: 32px;
	flex: 0 0 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 0;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.2);
	color: #fff;
	font-size: 14px;
	padding: 0;
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
}

.hero-swipe {
	margin: 14px 16px 0;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid var(--accent-line);
	background: #fff;
	box-shadow: var(--shadow);
}

.hero-swipe img {
	display: block;
	width: 100%;
	min-height: 128px;
	object-fit: cover;
}

.notice-card {
	min-height: 42px;
	margin: 12px 16px 0;
	padding: 0 8px;
	display: flex;
	align-items: center;
	border-radius: 12px;
	border: 1px solid var(--accent-line);
	background: var(--accent-soft);
	box-sizing: border-box;
}

.notice-icon {
	width: 28px;
	height: 28px;
	flex: 0 0 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background: #fff;
	color: var(--accent);
	font-size: 14px;
	box-shadow: 0 6px 14px rgba(255, 93, 122, 0.14);
}

.notice-text {
	min-width: 0;
	flex: 1;
	margin-left: 10px;
	color: var(--muted);
	font-size: 12px;
	line-height: 18px;
}

.quick-actions {
	margin: 12px 16px 0;
	padding: 12px 8px 10px;
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	border-radius: 14px;
	border: 1px solid var(--accent-line);
	background: #fff;
	box-shadow: var(--shadow);
	box-sizing: border-box;
}

.quick-action {
	min-height: 72px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 7px;
	border-right: 1px solid #f2edf0;
	color: var(--accent);
	text-align: center;
}

.quick-action:last-child {
	border-right: 0;
}

.quick-action img {
	width: 38px;
	height: 38px;
	object-fit: contain;
	filter: invert(51%) sepia(91%) saturate(1595%) hue-rotate(313deg) brightness(102%) contrast(101%);
}

.quick-action-label {
	width: 100%;
	padding: 0 4px;
	color: var(--accent);
	font-size: 12px;
	font-weight: 500;
	line-height: 17px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	box-sizing: border-box;
}

.popular-city-card {
	margin: 14px 16px 0;
	padding: 14px 16px 12px;
	display: flex;
	align-items: flex-start;
	border-radius: 14px;
	border: 1px solid var(--accent-line);
	background: #fff;
	color: var(--text);
	box-shadow: var(--shadow);
	box-sizing: border-box;
}

.popular-city-label {
	flex: 0 0 76px;
	padding-top: 2px;
	color: var(--accent);
	font-size: 14px;
	font-weight: 700;
	line-height: 22px;
	white-space: nowrap;
}

.popular-city-content {
	min-width: 0;
	flex: 1;
}

.popular-city-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	column-gap: 12px;
	row-gap: 9px;
}

.popular-city-item {
	min-width: 0;
	padding: 0 2px;
	color: var(--text);
	font-size: 12px;
	line-height: 22px;
	text-align: left;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.popular-city-more {
	width: max-content;
	max-width: 100%;
	min-height: 24px;
	margin: 14px auto 0;
	padding: 0 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid rgba(255, 93, 122, 0.48);
	border-radius: 7px;
	background: var(--accent-soft);
	color: var(--accent);
	font-size: 12px;
	line-height: 20px;
	box-sizing: border-box;
}

.girls-list-wrap {
	padding: 18px 16px 0;
}

.section-title {
	margin-bottom: 12px;
	color: var(--accent);
	font-size: 14px;
	font-weight: 700;
	line-height: 24px;
}

.girl-card {
	margin-bottom: 14px;
	padding: 14px;
	display: flex;
	border-radius: 14px;
	border: 1px solid var(--accent-line);
	background: #fff;
	box-shadow: var(--shadow);
	box-sizing: border-box;
}

.girl-media {
	position: relative;
	width: 118px;
	height: 118px;
	flex: 0 0 118px;
	overflow: hidden;
	border-radius: 10px;
	background: var(--accent-soft);
}

.girl-media img {
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover;
}

.corner-ribbon {
	position: absolute;
	top: -50px;
	right: -50px;
	z-index: 1;
	width: 90px;
	height: 90px;
	background: linear-gradient(180deg, #ff7791 0%, var(--accent-strong) 100%);
	color: #fff;
	transform: rotate(45deg);
}

.corner-ribbon i {
	position: absolute;
	bottom: 6px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	white-space: nowrap;
}

.girl-info {
	min-width: 0;
	flex: 1;
	margin-left: 14px;
}

.girl-topline {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.verify-chip {
	max-width: 46%;
	height: 24px;
	padding: 0 7px;
	display: inline-flex;
	align-items: center;
	border-radius: 6px;
	background: linear-gradient(180deg, #ff7791 0%, var(--accent-strong) 100%);
	color: #fff;
	font-size: 10px;
	// font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	box-sizing: border-box;
}

.verify-chip img {
	width: 13px;
	height: 13px;
	margin-right: 4px;
	object-fit: contain;
}

.girl-info h3 {
	margin: 9px 0 0;
	color: var(--text);
	font-size: 14px;
	font-weight: 700;
	line-height: 22px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.tags {
	min-height: 28px;
	margin-top: 7px;
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
}

.tag {
	max-width: 100%;
	padding: 0px 8px;
	border-radius: 8px;
	border: 1px solid var(--accent-line);
	background: var(--accent-soft);
	color: var(--accent);
	font-size: 10px;
	line-height: 28px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.rating-row,
.meta-row {
	margin-top: 7px;
	display: flex;
	align-items: center;
	color: var(--muted);
	font-size: 12px;
	line-height: 18px;
}

.rating-row span {
	margin-right: 5px;
}

.star {
	color: #ffd21e;
	font-size: 14px;
	margin-right: 1px;
}

.meta-row {
	gap: 10px;
	flex-wrap: wrap;
}

.meta-row span {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.date-btn {
	width: 100%;
	height: 34px;
	margin-top: 10px;
	border: 1px solid rgba(255, 93, 122, 0.42);
	border-radius: 10px;
	background: linear-gradient(180deg, #ff7791 0%, var(--accent-strong) 100%);
	color: #fff;
	font-size: 12px;
	font-weight: 700;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.dialog-img {
	display: block;
	width: 100%;
}

.popup {
	max-height: 60vh;
	padding: 22px;
	overflow-y: auto;
	color: var(--text);
	font-size: 14px;
	line-height: 20px;
}

/deep/ .van-swipe__indicators {
	bottom: 8px;
}

/deep/ .van-swipe__indicator {
	background-color: var(--accent);
}

/deep/ .van-list__loading,
/deep/ .van-list__finished-text {
	color: var(--muted);
}

@media screen and (max-width: 374px) {
	.hero-swipe,
	.notice-card,
	.quick-actions,
	.popular-city-card,
	.girls-list-wrap {
		margin-right: 12px;
		margin-left: 12px;
	}

	.home-top {
		padding-right: 12px;
		padding-left: 12px;
	}

	.brand-box {
		padding-left: 30px;
	}

	.girls-list-wrap {
		padding-right: 12px;
		padding-left: 12px;
	}

	.girl-card {
		padding-right: 12px;
		padding-left: 12px;
	}

	.girl-media {
		width: 104px;
		height: 146px;
		flex-basis: 104px;
	}

	.girl-info {
		margin-left: 12px;
	}

	.verify-chip {
		max-width: 100%;
	}

	.popular-city-card {
		padding-right: 12px;
		padding-left: 12px;
	}

	.popular-city-label {
		flex-basis: 70px;
		font-size: 12px;
	}

	.popular-city-grid {
		column-gap: 9px;
	}

	.popular-city-item {
		font-size: 12px;
	}

	.quick-action {
		min-height: 66px;
		gap: 6px;
	}

	.quick-action img {
		width: 32px;
		height: 32px;
	}

	.quick-action-label {
		font-size: 10px;
		line-height: 15px;
	}
}

.language {
	position: absolute;
	top: 6px;
	left: 15px;
	width: 32px;
	height: 32px;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 0;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.2);
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
}

.language img {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	object-fit: cover;
}

</style>
